import devLog from './devLog';
/**
 * ============================================================================
 * 🔥 NETWORK FIREWALL - DELETE/DESTROY/CLEAR ALL BLOCKED HOSTS
 * ============================================================================
 * V24.88.1 FIX: Disabled in preview environments to allow API calls to work
 */

const PRODUCTION_DOMAIN = 'https://app.elonprompt.ai';

// V24.88.1: Check if we're in a preview environment
const isPreviewEnvironment = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('preview.emergentagent.com') || 
         hostname.includes('emergent.host') ||
         hostname === 'localhost';
};

// DELETE/DESTROY/CLEAR_HOSTS - Pattern matching
// SECURITY: Preview URLs blocked to protect production OAuth flow
// V24.88.1: Only active in production, disabled in preview
const DESTROY_PATTERNS = [
  /admin-control-79\.emergent\.host/i,
  /\.emergent\.host/i,
  /emergent\.host/i,
  /preview\.emergentagent\.com/i
];

const mustDestroy = (url) => {
  // V24.88.1: Never destroy URLs in preview environment
  if (isPreviewEnvironment()) {
    return false;
  }
  if (!url) return false;
  return DESTROY_PATTERNS.some(p => p.test(url));
};

const destroy = (url) => {
  if (mustDestroy(url)) {
    console.error('🔥🔥🔥 [NETWORK] DESTROYED:', url);
    try {
      const u = new URL(url);
      const newUrl = `${PRODUCTION_DOMAIN}${u.pathname}${u.search}`;
      console.error('🔥🔥🔥 [NETWORK] REDIRECTED TO:', newUrl);
      return newUrl;
    } catch (e) {
      return PRODUCTION_DOMAIN;
    }
  }
  return url;
};

export const initNetworkFirewall = () => {
  if (typeof window === 'undefined') return;
  
  // V24.88.1: Skip firewall initialization in preview environments
  if (isPreviewEnvironment()) {
    devLog.log('🔥 [NETWORK FIREWALL] DISABLED in preview environment');
    return;
  }
  
  // INTERCEPT FETCH
  const origFetch = window.fetch;
  window.fetch = function(input, init) {
    if (input instanceof Request) {
      if (mustDestroy(input.url)) input = new Request(destroy(input.url), input);
    } else if (typeof input === 'string' && mustDestroy(input)) {
      input = destroy(input);
    }
    return origFetch.call(this, input, init);
  };
  
  // INTERCEPT XHR
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    return origOpen.call(this, method, destroy(url), ...args);
  };
  
  // INTERCEPT EventSource
  const OrigES = window.EventSource;
  window.EventSource = function(url, config) {
    return new OrigES(destroy(url), config);
  };
  window.EventSource.CONNECTING = OrigES.CONNECTING;
  window.EventSource.OPEN = OrigES.OPEN;
  window.EventSource.CLOSED = OrigES.CLOSED;
  
  devLog.log('🔥 [NETWORK FIREWALL] ACTIVE - DESTROYING:', DESTROY_PATTERNS.map(p => p.toString()));
};

export default initNetworkFirewall;
